/* src/app/components/payee-sectors/payee-sector-add-edit/payee-sector-add-edit.component.css */
.styled-table {
  border-collapse: collapse;
  margin: 25px 0;
  font-size: 0.9em;
  min-width: 400px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.15);
}
.styled-table thead tr {
  background-color: var(--navy-600);
  color: var(--bg-surface);
  text-align: left;
}
.styled-table th,
.styled-table td {
  padding: 12px 15px;
}
.styled-table tbody tr {
  border-bottom: 1px solid var(--border);
}
.styled-table tbody tr:nth-of-type(even) {
  background-color: var(--gray-100);
}
.styled-table tbody tr:last-of-type {
  border-bottom: 2px solid var(--navy-600);
}
.styled-table tbody tr.active-row {
  font-weight: bold;
  color: var(--navy-600);
}
/*# sourceMappingURL=payee-sector-add-edit.component.css.map */
